/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum BlockedAccessSubjectType {
  GROUP = "GROUP",
  USER = "USER",
}

export enum ResourceAccessType {
  EDIT = "EDIT",
  VIEW = "VIEW",
}

export interface BlockedAccessSubjectInput {
  subjectId: string;
  subjectType: BlockedAccessSubjectType;
}

//==============================================================
// END Enums and Input Objects
//==============================================================

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ResolveRestrictionsForSubjectsMutation
// ====================================================

export interface ResolveRestrictionsForSubjectsMutation_resolveRestrictionsForSubjects_errors {
  message: string | null;
}

export interface ResolveRestrictionsForSubjectsMutation_resolveRestrictionsForSubjects {
  success: boolean;
  errors: ResolveRestrictionsForSubjectsMutation_resolveRestrictionsForSubjects_errors[];
}

export interface ResolveRestrictionsForSubjectsMutation {
  resolveRestrictionsForSubjects: ResolveRestrictionsForSubjectsMutation_resolveRestrictionsForSubjects | null;
}

export interface ResolveRestrictionsForSubjectsMutationVariables {
  accessType: ResourceAccessType;
  contentId: any;
  subjects: (BlockedAccessSubjectInput | null)[];
}
